import { useModal } from "mui-modal-provider";
import { useCallback } from "react";
import { CalledFortuneTeller, TelWaitingFortuneTeller } from "shared/types";
import { OrderModal } from "../components/OrderModal";

export const useOrderModal = () => {
  const { showModal, ...rest } = useModal();

  const showOrderModal = useCallback(
    (fortuneTeller: CalledFortuneTeller | TelWaitingFortuneTeller) => {
      showModal(OrderModal, { fortuneTeller });
    },
    [showModal]
  );

  return {
    showModal: showOrderModal,
    ...rest,
  };
};
